import { createContext } from "react";
import { FooterDataType } from "src/assets/Types/Redesign/FooterDataType.type";

export const FooterContext = createContext<FooterDataType>({
  appLinks: null,
  column: [],
  essentialLinks: [],
  logo: null,
  securityIcons: [],
  socialLinks: null,
  onClick: () => {},
});
